// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OmemX","option":"styles_option__1uPG-","active":"styles_active__xsIa0"};